import { render, staticRenderFns } from "./NoticeBar.vue?vue&type=template&id=133f3870&scoped=true&"
import script from "./NoticeBar.vue?vue&type=script&lang=js&"
export * from "./NoticeBar.vue?vue&type=script&lang=js&"
import style0 from "./NoticeBar.vue?vue&type=style&index=0&id=133f3870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133f3870",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/ubq-h5_build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('133f3870')) {
      api.createRecord('133f3870', component.options)
    } else {
      api.reload('133f3870', component.options)
    }
    module.hot.accept("./NoticeBar.vue?vue&type=template&id=133f3870&scoped=true&", function () {
      api.rerender('133f3870', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/components/NoticeBar.vue"
export default component.exports